import { PropsWithChildren, useEffect } from 'react';

import { BASE_FONT_SIZE, useDeviceView } from 'shared/utils/useDeviceView';
import { useWorkMode } from 'shared/utils/useWorkMode';

export function GlobalStylesProvider(props: PropsWithChildren) {
  const { children } = props;

  const { htmlFontSize: deviceViewFontSize } = useDeviceView();
  const { isStudioEdit, isStudioMainPage, isThemePreview } = useWorkMode();
  const htmlFontSize = isStudioEdit || isStudioMainPage || isThemePreview ? BASE_FONT_SIZE : deviceViewFontSize;

  useEffect(() => {
    if (!htmlFontSize || htmlFontSize <= 0) {
      return;
    }

    const root = document.documentElement;
    root.style.fontSize = `${htmlFontSize}px`;

    return () => {
      root.style.removeProperty('font-size');
    };
  }, [htmlFontSize]);

  return <>{children}</>;
}
